import FirstFixingDate from '@/App/tiles/TargetAccumulator/FirstFixingDate.tsx';
import FixingFrequencies from '@/App/tiles/TargetAccumulator/FixingFrequencies.tsx';
import LastFixingDate from '@/App/tiles/TargetAccumulator/LastFixingDate.tsx';
import SettlementFrequency from '@/App/tiles/TargetAccumulator/SettlementFrequency.tsx';
import SettlementMode from '@/App/tiles/TargetAccumulator/SettlementMode';

export const InputGroup3 = ({ useShortLabels = false }: { useShortLabels?: boolean }) => (
  <>
    <FirstFixingDate />
    <LastFixingDate />
    <FixingFrequencies />
    <SettlementFrequency useShortLabel={useShortLabels} />
    <SettlementMode useShortLabel={useShortLabels} />
  </>
);
